import dayjs from "dayjs";
import { array, date, object } from "yup";
import { supportsExpenses } from "../purchase-return-rules";
import { ReturnableTypeEnum } from "../returnable-type";
import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  returnableId: null, // The source document ID (GR or PI)
  // Reference number of the source invoice; the expense picker resolves an
  // invoice's expense lines by reference number, not by id.
  returnableReferenceNumber: null,
  returnableType: ReturnableTypeEnum.GOODS_RECEIPT,
  warehouse: null, // Warehouse for NON_INVOICE returns
  note: null,
  returnableProductVariants: [],
  // Expense lines of the source purchase invoice being returned (PI only).
  purchaseReturnExpenses: [],
  discountAmount: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxPercentage: 11,
};

export const VALIDATION_SCHEMA = object().shape({
  buyer: object().required("Harus diisi"),
  seller: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  warehouse: object().when("returnableType", {
    is: ReturnableTypeEnum.NON_INVOICE,
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.nullable(),
  }),
  // An invoice return may consist of expenses alone; every other source
  // must return at least one product.
  returnableProductVariants: array().when(
    ["returnableType", "purchaseReturnExpenses"],
    {
      is: (returnableType, purchaseReturnExpenses) =>
        supportsExpenses(returnableType) &&
        (purchaseReturnExpenses ?? []).length > 0,
      then: (schema) => schema,
      otherwise: (schema) =>
        schema.min(1, "Harus memiliki setidaknya satu produk"),
    }
  ),
});
